import React from 'react';
// import '../App';
import '../style/recipedetail.css';

// function Recipedetail(props) 
const Recipedetail = ({ingredient}) => {
    console.log("ingrdients",ingredient);
 return ingredient.map((ing,i)=>{
     return(
         <ul key={i} className="ingredient-list">
            <li className="ingredient-text">{ing.text}</li>
            <li className="ingredient-weight">Weight-{ing['weight']}</li>
         </ul>
     )
 }
 )
}


export default Recipedetail;